import { render, staticRenderFns } from "./devolucionBodegaHistorial.vue?vue&type=template&id=8da9afa4&scoped=true"
import script from "./devolucionBodegaHistorial.vue?vue&type=script&lang=js"
export * from "./devolucionBodegaHistorial.vue?vue&type=script&lang=js"
import style0 from "./devolucionBodegaHistorial.vue?vue&type=style&index=0&id=8da9afa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da9afa4",
  null
  
)

export default component.exports